import { useMutation } from "@tanstack/react-query";
import { useEngagementsInvalidate } from "PFCore/hooks/queries/engagements/use_engagements_invalidate";
import { useRolesInvalidate } from "PFCore/hooks/queries/roles/use_roles_invalidate";
import { OwnerUpdatePayload, updateOwner } from "PFCore/services/owners";
import { Owner } from "PFTypes";
import { MutationOptions } from "PFTypes/request_options";

import { useActivityInvalidate } from "../activity/use_activity_invalidate";

export const useOwnerUpdate = (
  activityId: number,
  { onSuccess, ...options }: MutationOptions<OwnerUpdatePayload & { id: number }> = {}
) => {
  const { invalidate: invalidateActivity } = useActivityInvalidate();
  const { invalidateRoles } = useRolesInvalidate();
  const { invalidateAll: invalidateEngagements } = useEngagementsInvalidate();

  return useMutation({
    mutationFn: (payload: OwnerUpdatePayload & { id: number }) => updateOwner(payload.id, payload),
    onSuccess: (data: Owner, ...params) => {
      invalidateActivity([activityId]);
      invalidateRoles();
      invalidateEngagements();
      onSuccess?.(data, ...params);
    },
    ...options
  });
};
